<template>
  <div class="ch-container">
    <el-card>
      <div slot="header">
        <el-menu
          :default-active="activeIndex"
          @select="onSelect"
          class="ch-user-menu"
          mode="horizontal"
        >
          <el-menu-item v-for="(item,index) in ments" :index="item.path" :key="index" >{{item.lable}}</el-menu-item>
        </el-menu>
      </div>
      <transition name="fade">
        <router-view />
      </transition>
    </el-card>
  </div>
</template>

 <script>
export default {
  data() {
    return {
      activeIndex: "",
      ments: [
        {
          lable: "我的项目",
          path: "/user/project",
        },
        {
          lable: "账户信息",
          path: "/user/info",
        },
        // {
        //   lable: "消息中心",
        //   path: "/user/msg",
        // },
      ],
    };
  },
  watch:{
    "$route"(to) {
      console.log(to);
      this.activeIndex = to.path
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      console.log(this.$route);
      let route = this.$route;
      this.activeIndex = route.path;
    },
    onSelect(index) {
      if (index === this.activeIndex) {
        console.log(111)
        return;
      }
      this.activeIndex = index
      this.$router.push({ path: index });
    },
  },
};
</script>

<style lang="less" scoped>
.ch-user-menu {
  margin-bottom: -19px;
}
/deep/ .el-input-group__append {
  background-color: #3a84f7 !important;
  border-color: #3a84f7 !important;
  color: #ffffff;
}
</style>